<template>
    <div
        :class="{calculate: !price, show: price}"
    >
        <template
            v-if="price <= 0"
        >
            <options
                placeholder="transfer.type"
                :options="types"
                @select="set('type', $event)"
            />
            <options
                v-if="!empty(meetings)"
                placeholder="transfer.meeting"
                :options="meetings"
                @select="set('meeting', $event)"
            />
            <options
                v-if="!empty(destinations)"
                placeholder="transfer.destination"
                :options="destinations"
                @select="set('destination', $event)"
            />
            <options
                v-if="!empty(passengers)"
                placeholder="transfer.passengers"
                :options="passengers"
                @select="set('passenger', $event)"
            />
            <template
                v-if="getPrice"
            >
                <button
                    class="btn calculate"
                    style="cursor: pointer;"
                    @click.prevent="showPrice"
                >
                    {{ 'transfer.calculate' | trans}}
                </button>
            </template>
        </template>
        <template
            v-else
        >
            <ul>
                <li>
                    <div class="text-input gl">
                        <span>{{ 'transfer.type' | trans }}</span>
                        <p class="truncate">{{ `transfer.${type}` | trans }}</p>
                    </div>
                </li>
                <li>
                    <div class="text-input gl">
                        <span>{{ 'transfer.meeting' | trans }}</span>
                        <p class="truncate">{{ text_meeting }}</p>
                    </div>
                    <div class="text-input gl">
                        <span>{{ 'transfer.destination' | trans }}</span>
                        <p class="truncate">{{ text_destination }}</p>
                    </div>
                    <div class="text-input gl">
                        <span>{{ 'transfer.passengers' | trans }}</span>
                        <p class="truncate">{{ passenger }}</p>
                    </div>
                </li>
            </ul>
            <div class="price-container">
                <div class="price">
                    <div>
                        <h3>
                            {{ price | num_format }} €
                            <span class="exo small">
                                ({{ priceByPerson | num_format }} €/{{ 'transfer.person' | trans }})
                                <br>
                                {{ 'transfer.alert' | trans }}
                            </span>
                        </h3>
                    </div>
                    <div class="action">
                        <button
                            type="submit"
                            class="btn"
                            @click.prevent="submit"
                        >
                            {{ 'transfer.send' | trans }}
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import Options from './components/Options';
import { isNil, isEmpty, indexOf } from 'ramda';

const route = '/api/v1/transfer';
const store = window.$transfer.store;
const cart = window.$transfer.cart;

const TYPES = [
    'type',
    'meeting',
    'destination',
    'passenger',
    'end'
];

const ROUND = [
    'round_arrive',
    'round_leave'
];

export default {
    name: 'app',
    data() {
        return {
            update: true,
            type: '',
            meeting: '',
            text_meeting: '',
            destination: '',
            text_destination: '',
            passenger: 0,
            price: 0,
            types: [],
            meetings: [],
            destinations: [],
            passengers: [],
            getPrice: false
        };
    },
    computed: {
        priceByPerson() {
            return this.price / this.passenger;
        }
    },
    methods: {
        showPrice() {
            const query = {
                meeting: this.meeting,
                destination: this.destination,
                passengers: this.passenger
            };
            this.$groovie
                .get(`${route}/${this.type}`, query)
                .then(data => this.$set(this, 'price', data))
                .catch(error => console.error(error));
        },
        empty(value) {
            return isEmpty(value);
        },
        get(type = 'type') {
            let _route = route;
            const filters = {};

            if (!isEmpty(this.type) && !isNil(this.type) && type !== 'type') {
                _route += `/${this.type}`;
            }

            if (type !== 'type' && !isEmpty(this.meeting)) {
                filters.meeting = this.meeting;
            }

            if (type !== 'type' && !isEmpty(this.destination)) {
                filters.destination = this.destination;
            }

            this.$groovie
                .get(_route, filters)
                .then((data) => {
                    let values = data;

                    if (!(data instanceof Array)) {
                        values = [];
                        for (const key in data) {
                            values.push({
                                label:  data[key],
                                value: key
                            });
                        }
                    } else if (data instanceof Array) {
                        values = [];
                        for (const key in data) {
                            let label = this.$options.filters.trans(`transfer.${data[key]}`);
                            
                            if (!isEmpty(this.type) && !isEmpty(this.meeting) && !isEmpty(this.destination)) {
                                label = `${data[key]}`;
                            }

                            values.push({
                                label,
                                value: data[key]
                            });
                        }
                    }
                    
                    this.$set(this, `${type}s`, values);
                })
                .catch(error => console.error(error));
        },
        set(type, evt) {
            const next = TYPES[indexOf(type, TYPES) + 1];
            let value = evt;

            this.$set(this, type, value);

            if (type === 'meeting' || type === 'destination') {
                for (const key in this[`${type}s`]) {
                    const option = this[`${type}s`][key];
                    if (option.value == evt) {
                        value = option.label;
                        break;
                    }
                }
                console.log(type, `${type}s`, value, evt, this[`${type}s`]);
                this.$set(this, `text_${type}`, value);
            }

            this.$set(this, next, '');
            this.$set(this, `${next}s`, []);

            if (next !== 'end') {
                this.get(next);
            } else {
                this.$set(this, 'getPrice', true);
            }
        },
        submit() {
            const data = {
                item: this.type,
                type: 'transfer',
                attributes: {
                    icon: 'icon-transfer',
                    passengers: this.passenger,
                    meeting: this.meeting,
                    destination: this.destination
                }
            };

            this.$groovie
                .post(store, data)
                .then(() => {
                    window.location.href = cart;
                })
                .catch(error => console.error(error));
        }
    },
    mounted() {
        if (this.types.length === 0) {
            this.get();
            this.update = false;
        }
    },
    updated() {
        if (this.update) {
            this.get();
        }
    },
    components: {
        Options
    }
};
</script>



// WEBPACK FOOTER //
// src/App.vue